import { useState } from "react";
import { FileCheck2 } from "lucide-react";
import { toast } from "sonner";
import { qualApi, qualErr, CARD, INPUT, BTN, LABEL } from "./esriQualApi";
import { DateField } from "./DateField";

const ITEMS = [
  { item: "esri_usage_rights", label: "Droits applicables aux essais (références documentaires)" },
  { item: "proxy_architecture", label: "Relais Backend authentifié autorisé" },
  { item: "dissemination_scope", label: "Périmètre : qualification interne", scope: "QUALIFICATION_INTERNAL" },
  { item: "real_calls_authorized", label: "Autorisation explicite des appels Esri réels", validity: true },
];
const today = () => new Date().toISOString().slice(0, 10);

function EvidenceRow({ def, current, onChange }) {
  const [reference, setReference] = useState(current?.reference || "");
  const [date, setDate] = useState(current?.document_date || today());
  const [until, setUntil] = useState(current?.valid_until ? current.valid_until.slice(0, 10) : "");
  const ok = current?.confirmed === true;
  const send = async (confirmed) => {
    try {
      await qualApi.declare({ item: def.item, confirmed, reference, document_date: date, scope: def.scope || null, valid_until: def.validity && until ? `${until}T23:59:00+00:00` : null });
      toast.success(confirmed ? "Déclaration enregistrée (datée, journalisée)" : "Déclaration révoquée"); onChange();
    } catch (e) { toast.error(qualErr(e)); }
  };
  return (
    <div data-testid={`esri-evidence-${def.item}`} data-confirmed={ok ? "1" : "0"} className="border border-white/10 rounded-sm p-3 space-y-2">
      <div className="font-mono text-[11px] flex justify-between gap-2"><span>{def.label}</span><span className={ok ? "text-[#22C55E]" : "text-[#F59E0B]"}>{ok ? `DÉCLARÉ ${current.declared_by || ""}` : "EN ATTENTE"}</span></div>
      <div className="grid sm:grid-cols-[1fr_140px_140px] gap-2">
        <div><label className={LABEL}>Référence vérifiable</label><input data-testid={`esri-evidence-${def.item}-ref`} value={reference} onChange={(e) => setReference(e.target.value)} className={INPUT} maxLength={300} /></div>
        <div><label className={LABEL}>Date de validation</label><DateField testid={`esri-evidence-${def.item}-date`} value={date} onChange={setDate} max={today()} /></div>
        {def.validity ? <div><label className={LABEL}>Valide jusqu'au</label><DateField testid={`esri-evidence-${def.item}-until`} value={until} onChange={setUntil} min={today()} /></div> : <div />}
      </div>
      <div className="flex gap-2">
        <button data-testid={`esri-evidence-${def.item}-confirm`} onClick={() => send(true)} disabled={reference.length < 8 || (def.validity && !until)} className={BTN}><FileCheck2 size={12} /> Déclarer</button>
        {ok && <button data-testid={`esri-evidence-${def.item}-revoke`} onClick={() => send(false)} className={`${BTN} text-[#EF4444]`}>Révoquer</button>}
      </div>
    </div>
  );
}

export function EvidenceCard({ evidence, onChange }) {
  return (
    <section data-testid="esri-evidence-card" className={CARD}>
      <h2 className="font-chivo text-base md:text-lg font-black uppercase tracking-tight">Déclarations (facultatives)</h2>
      <p className="font-mono text-[10px] text-[#F59E0B]">Non bloquantes pour les essais internes (E204 §2.1(b) : développement, test et démonstration d'un prototype). Une déclaration ne crée aucun droit contractuel. Requises pour le profil COMMERCIAL : NO-GO (Issue #2).</p>
      {ITEMS.map((d) => <EvidenceRow key={d.item} def={d} current={evidence[d.item]} onChange={onChange} />)}
    </section>
  );
}
